// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".show-checkbox-error[data-v-d342a5d8] {\n  background-color: var(--red-600);\n  border-color: rgba(var(--red-600), 0.5);\n}", ""]);
// Exports
module.exports = exports;
